export enum PayoutMethodType {
  P2P = "p2p",
  FondyMerchant = "fondy_merchant",
  BankTransfer = "bank_transfer",
}
